import { render, staticRenderFns } from "./Nucleo.vue?vue&type=template&id=775b76c9"
import script from "./Nucleo.vue?vue&type=script&lang=js"
export * from "./Nucleo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports